/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Reservations_DescriptionInputs */

const en_inventory_reservations_description = /** @type {(inputs: Inventory_Reservations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage manual holds and review checkout or contract draft reservations`)
};

const es_inventory_reservations_description = /** @type {(inputs: Inventory_Reservations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra apartados manuales y revisa reservas de checkout o borradores de contrato`)
};

/**
* | output |
* | --- |
* | "Manage manual holds and review checkout or contract draft reservations" |
*
* @param {Inventory_Reservations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_reservations_description = /** @type {((inputs?: Inventory_Reservations_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Reservations_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_reservations_description(inputs)
	return es_inventory_reservations_description(inputs)
});